<script setup>
defineProps({
  active: {type: Boolean, required: true},
  title: {type: String, default: 'Підпис об\'єкта'},
});
const emit = defineEmits(['update:active']);
</script>

<template>
  <div class="sign-modal" :class="{active}" @click="emit('update:active', false)">
    <div class="sign-modal__content" :class="{active}"  @click.stop>
      <div class="sign-modal__head">
        <h5 class="fs-18 fw-500">{{ title }}</h5>
        <button class="bg-white p-8" @click="emit('update:active', false)">
          <i class="i-x grey"/>
        </button>
      </div>
      <div class="sign-modal__body">
        <div id="sign-widget-parent" class="sign-widget"/>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.sign-widget {
  height: inherit;
  width: 100%;
}
</style>
